module.exports = __webpack_public_path__ + "img/theme3.2d9054eb.png";